<div class="api-specification">
  <h2>Properties</h2>
  <table>
    <thead>
      <tr>
        <th>Property</th>
        <th>Type</th>
        <th>Default Value</th>
        <th>Description</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td><code>actionName</code></td>
        <td><code>string</code></td>
        <td><code>''</code></td>
        <td>The tooltip text and accessible label of the action button.</td>
      </tr>
      <tr>
        <td><code>id</code></td>
        <td><code>string</code></td>
        <td><code>''</code></td>
        <td>(Optional) Sets the HTML id attribute on the rendered anchor element.</td>
      </tr>
      <tr>
        <td><code>icon</code></td>
        <td><code>string</code></td>
        <td><code>'add'</code></td>
        <td>The Material icon name displayed inside the action button.</td>
      </tr>
      <tr>
        <td><code>routerLink</code></td>
        <td><code>string</code></td>
        <td><code>''</code></td>
        <td>The router link used for navigation when the action button is clicked.</td>
      </tr>
      <tr>
        <td><code>liftHigher</code></td>
        <td><code>boolean</code></td>
        <td><code>true</code></td>
        <td>
          Moves the floating action button higher to provide additional bottom spacing, for example when a fixed paginator or footer is
          present.
        </td>
      </tr>
      <tr>
        <td><code>liftHigher2</code></td>
        <td><code>boolean</code></td>
        <td><code>false</code></td>
        <td>Renders the button as a mini-fab and adjusts its floating position.</td>
      </tr>
    </tbody>
  </table>

  <h2>Events</h2>
  <table>
    <thead>
      <tr>
        <th>Event</th>
        <th>Description</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td><code>-</code></td>
        <td>This component does not expose custom output events. Navigation is handled through <code>routerLink</code>.</td>
      </tr>
    </tbody>
  </table>
</div>
